export const USER_MUST_SAVE_ERROR_KEY = '__initialFormError';
export const USER_MUST_SAVE_ERROR_MESSAGE = 'Please edit the form to continue.';
